import TombolaBaseComponent from '@/components/base/base.component';
import { Component, Prop } from 'vue-property-decorator';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';

@Component({
  name: 'MinimisedModalComponent'
})

class MinimisedModalComponent extends TombolaBaseComponent {
  @Prop() public minimizedModalId: string;
  @Prop() public modalTitle: string;
  @Prop() public modalTooltip: string;

  public restoreModal() {
    this.$modalManager.restoreSelectedModal(this.minimizedModalId);
    this.destroySelf();
  }

  private destroySelf() {
    this.$destroy();
    this.$el.remove();
  }

  private populateStylingClasses() {
    let stylingClasses = '';
    const gameNameProperty = 'gameName';
    const clubNameProperty = 'clubName';

    stylingClasses = this.$tombolaStore.Get(UserPreferences).country + ' ';
    stylingClasses += 'minimised-modal ' + this.modalTitle.replace(' ', '-');

    return stylingClasses.toLocaleLowerCase();
  }
}

export default MinimisedModalComponent;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/home/_components/minimised-modal/minimised-modal.component.ts